// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-download-elements-buttons {
    width: 130px;
    height: 35px;
}

.download-type-width {
    width: 270px;
}

[data-download-type-button] {
    height: 35px;
}

[data-download-type-button-content] {
    display: flex;
    width: 220px;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/custom-download-element.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".custom-download-elements-buttons {\n    width: 130px;\n    height: 35px;\n}\n\n.download-type-width {\n    width: 270px;\n}\n\n[data-download-type-button] {\n    height: 35px;\n}\n\n[data-download-type-button-content] {\n    display: flex;\n    width: 220px;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
